import { DataTypeForm, validateIdentifier } from "../../../../../features/data-types"
import { PanelWrapper, Data, FieldType, FormField, useGetCrumbs, O } from "../../../../../features/ui"
import { useActions } from "./actions"
import { useNavigate } from "react-router-dom"
import { RoutePath, useRoutesHooks } from "../../../../../features/routes"
import { Driver } from "../../../state/types"

export const DriverForm = () => {
    const { dataType } = useRoutesHooks().parseUrl()
    const driver = dataType as O<Driver>
    const createMode = !driver

    const navigate = useNavigate()

    const { submitDriver } = useActions()

    const driverLabel = driver ? `: ${driver.name}` : ''
    const title = `${createMode ? 'Crear' : 'Editar'} Conductor${driverLabel}`

    const crumbs = useGetCrumbs(
        'Conductores',
        RoutePath.DRIVERS,
        driver?.name,
        undefined,
        createMode ? 'Crear' : 'Editar'
    )

    const fields: FormField[] = [
        {
            name: 'name',
            type: FieldType.TEXT,
            label: 'Nombre'
        },
        {
            name: 'identifier',
            type: FieldType.NUMBER,
            label: 'DNI',
            integer: true,
            validate: validateIdentifier
        }
    ]

    const onSubmit = (driverData: Data) => {
        submitDriver(driverData, createMode)
    }

    const onCancel = () => navigate(-1)

    return (
        <PanelWrapper title={title} crumbs={crumbs}>
            <DataTypeForm
               formId="driver-form"
               fields={fields}
               createMode={createMode}
               onSubmit={onSubmit}
               onCancel={onCancel}
            />
        </PanelWrapper>
    )
}
